import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import {
  ReceiptVerificationStatus,
  receiptVerificationStatusToTooltip,
} from 'src/models/receiptVerification.models'
import { css } from 'styled-components'

interface AttachmentVerificationTooltipProps {
  status?: ReceiptVerificationStatus
  reasons?: string[]
}

function isPositiveStatus(status?: ReceiptVerificationStatus): boolean {
  return (
    status === ReceiptVerificationStatus.Verified ||
    status === ReceiptVerificationStatus.AutoMatched
  )
}

function defaultReasonsForStatus(status?: ReceiptVerificationStatus): string[] {
  if (isPositiveStatus(status)) {
    return ['Verified amount', 'Verified date', 'Verified merchant']
  }
  return []
}

function CheckGlyph(): React.ReactElement {
  return <span aria-hidden="true">{'✅'}</span>
}

function CrossGlyph(): React.ReactElement {
  return <span aria-hidden="true">{'❌'}</span>
}

export default function AttachmentVerificationTooltip({
  status,
  reasons,
}: AttachmentVerificationTooltipProps): React.ReactElement {
  const translate = useTranslate()

  const effectiveReasons =
    reasons && reasons.length > 0 ? reasons : defaultReasonsForStatus(status)

  if (effectiveReasons.length === 0) {
    return <span>{translate(receiptVerificationStatusToTooltip(status))}</span>
  }

  const positive = isPositiveStatus(status)

  return (
    <ul
      css={css`
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
      `}
    >
      {effectiveReasons.map((reason, i) => (
        <li
          key={`${reason}-${i}`}
          css={css`
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 12px;
            line-height: 16px;
          `}
        >
          <span
            css={css`
              flex-shrink: 0;
              font-size: 12px;
              line-height: 1;
            `}
          >
            {positive ? <CheckGlyph /> : <CrossGlyph />}
          </span>
          <span>{translate(reason)}</span>
        </li>
      ))}
    </ul>
  )
}
